/** Null when the URL already carries the `lr` marker — we reloaded once; reloading again would loop. */
export function buildLazyReloadUrl(href: string): string | null {
	const url = new URL(href);
	if (url.searchParams.has("lr")) {
		return null;
	}
	url.searchParams.set("lr", "");
	return url.toString();
}
